const BYTES_PER_UNIT = 1024;

/**
 * Formats a byte count as a human-readable file size, stepping up from KB to MB
 * once the value reaches a megabyte so large files don't read as "3,845 KB".
 *
 * @param bytes - The file size in bytes
 * @returns The size rendered in whole KB (e.g. "842 KB") or one-decimal MB
 * (e.g. "3.8 MB")
 *
 * @example
 * formatFileSize(842 * 1024) // '842 KB'
 * formatFileSize(3.8 * 1024 * 1024) // '3.8 MB'
 */
export const formatFileSize = (bytes: number): string => {
  const kb = bytes / BYTES_PER_UNIT;
  if (kb < BYTES_PER_UNIT) {
    return `${Math.round(kb)} KB`;
  }
  return `${(kb / BYTES_PER_UNIT).toFixed(1)} MB`;
};
